export default __webpack_public_path__ + "static/media/0xf81628edeb110a73c016ab7afa57d80afae07f59.a1d76fb4.png";